/**
 * @author Rosa
 */
export class InstructionComponent extends HTMLElement {
    private overlay!: HTMLDivElement;

    /**
     * ConnectedCallback
     * This method is called when the custom element is inserted into the DOM.
     * It sets up the shadow DOM and calls the render method to display the content.
     */
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    /**
     * render
     * @returns void
     */
    private render(): void {
        if (!this.shadowRoot) return;

        this.shadowRoot.innerHTML = `
            <style>
                .overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    background: rgba(0, 0, 0, 0.85);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 9999;
                    backdrop-filter: blur(4px);
                    animation: fadeIn 0.3s ease-in-out;
                }

                .popup-content {
                    background-color: rgba(20, 20, 59, 0.95);
                    padding: 40px;
                    border: 2px solid rgb(144, 45, 231);
                    border-radius: 16px;
                    box-shadow: 0 0 10px rgb(169, 2, 230);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    animation: popupZoom 0.4s ease-out;
                    width: 900px;
                    max-width: 90%;
                }

                .popup-content h2 {
                    text-shadow: none;
                    font-size: 1.5rem;
                    font-weight: bold;
                    color: rgb(180, 118, 238);
                    margin-top: 5px;
                    margin-bottom: 10px;
                    text-align: center;
                }

                .popup-content hr {
                    width: 100%;
                    border: 1px solid hsla(261, 91.00%, 78.20%, 0.80);
                    margin: 10px 0;
                }

                .popup-content p {
                    text-shadow: none;
                    color: rgb(167, 206, 231);
                    margin-bottom: 5px;
                    text-align: center;
                    line-height: 1;
                    font-size: 1.5rem;
                }

                .epilepsy-warning {
                    text-shadow: none;
                    color: rgb(200, 115, 137) !important;
                    font-weight: bold;
                    text-align: center;
                    text-shadow: none !important;
                    margin-top: 20px;
                    margin-bottom: 10px;
                }

                .popup-content button {
                    padding: 10px 20px;
                    border-radius: 5px;
                    border: 1px solid rgb(121, 73, 167);
                    background: hsla(273, 57.80%, 67.50%, 0.80);
                    color: black;
                    cursor: pointer;
                    margin-top: 20px;
                    transition: 0.3s ease-in-out;
                }

                .popup-content button:hover {
                    background: hsla(273, 70.50%, 76.10%, 0.80);
                    transform: scale(1.10); 
                }

                .popup-content button:active {
                    transform: scale(1.1);
                    transition: transform 0.1s ease-in-out;
                }

                @keyframes popupZoom {
                    0% {
                        opacity: 0;
                        transform: scale(0.8);
                    }
                    100% {
                        opacity: 1;
                        transform: scale(1);
                    }
                }

                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @media (max-width: 768px) {
                .popup-content {
                    width: 90%;
                    padding: 20px;
                }

                .popup-content h2 {
                    font-size: 1.2rem;
                }

                .popup-content p {
                    font-size: 1rem;
                }

                .popup-content button {
                    padding: 8px 16px;
                    font-size: 0.9rem;
                }
            }

            @media (max-width: 480px) {
                .popup-content {
                    width: 95%;
                    padding: 15px;
                }

                .popup-content h2 {
                    font-size: 1rem;
                }

                .popup-content p {
                    font-size: 0.9rem;
                }

                .popup-content button {
                    padding: 6px 12px;
                    font-size: 0.8rem;
                }
            }
            </style>
            <div class="overlay">
                <div class="popup-content">
                <h2>How to play CYBER REVERB?</h2>
                <hr>
                    <p>
                    Welcome to CYBER REVERB, a retro-futuristic text-based adventure game. Your goal is to uncover the secrets of your past by exploring iconic cities, solving puzzles, and making critical decisions.
                    </p>
                <p>
                    Navigate through the world map to visit various cities. 🌍
                    Interact with characters to gather information and collect all items.
                    Solve all the puzzles in all countries in order to get to Atlantis to choose your ending.
                    Use your inventory to manage collected items.
                    Your choices will shape the outcome of the game, so choose wisely!
                </p>
                <p>
                    Click on buttons to interact with the game.
                    Use the on-screen prompts to make decisions.
                    Pay attention to the dialogue and clues provided by characters.
                </p>
                <p>Good luck, Hacker 204. The fate of Atlantis depends on you!</p>
                <p class="epilepsy-warning">⚠️: This game can contain triggers that may not be suitable for individuals with epilepsy.</p>
                <button id="close-button">Okay, got it!</button>
            </div>
            </div>
        `;

        this.overlay = this.shadowRoot.querySelector(".overlay") as HTMLDivElement;
        const closeButton: HTMLButtonElement = this.shadowRoot.querySelector("#close-button") as HTMLButtonElement;

        closeButton.addEventListener("click", () => this.closePopup());
    }

    /**
     * closePopup
     * This method is called when the close button is clicked.
     * It hides the overlay by setting its display to "none".
     * @returns void
     */
    private closePopup(): void {
        this.overlay.style.display = "none";
    }
}
